import { render } from "./AboutTectStack.vue?vue&type=template&id=4bcc44c7"
import script from "./AboutTectStack.vue?vue&type=script&lang=js"
export * from "./AboutTectStack.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__